import React from 'react';
import cn from 'classnames';

import s from './Loader.module.scss';
import {PuffLoader} from "react-spinners";

const Loader = ({attrs}) => {
    const attrsMerge = {
        ...attrs,
        className: cn(s.wrap, attrs && attrs.className),
    };

    return (
        <div {...attrsMerge} className={cn('loading', s.loader)}>
            <PuffLoader color='#0502ae' />
        </div>
    );
};

export default Loader;
